import { CustomFile } from '../model/types/File.types'

export const isCustomFile = (file: unknown): file is CustomFile =>
  file !== null &&
  typeof file === 'object' &&
  'id' in file &&
  'extension' in file &&
  'visibleName' in file
